import {
  Dialog,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import moment from 'moment';

import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { Link } from 'react-router-dom';
import setTableCellType from 'utils/setTableCellType';

const ContractInfoModal = (props) => {
  const { open, setOpen, data, setData } = props;
  const { t } = useTranslation();

  const headCells = [
    { code: 'name', label: t('common.fields.contractName') },
    { code: 'sum', label: `${t('common.fields.contractSum')} (UZS)` },
    { code: 'valute', label: `${t('common.fields.contractSum')} ($)` },
    { code: 'staff', label: t('common.fields.staff') },
    { code: 'total_square', label: t('order.modal.add.home.areaAll') },
  ];
  const columns = [
    { code: 'name' },
    { code: 'sum', type: 'price' },
    { code: 'valute', type: 'priceValute' },
    { code: 'staff', type: 'nested', childStr: 'name' },
    { code: 'total_square', type: 'area' },
  ];

  const handleClose = () => {
    setOpen(false);
    setData({});
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
      maxWidth='lg'
      PaperProps={{
        className: '!base-border !shadow-none min-w-[75vw]',
      }}
    >
      <DialogTitle
        id='alert-dialog-title'
        className='!mb-5 text-center !bg-[#CDCDCDC7]'
      >
        <span>
          {t('boss.arrears.title')}:{' '}
          {moment(data?.date, 'YYYY-MM-DD').format('DD.MM.YYYY')}
        </span>
      </DialogTitle>

      <DialogContent>
        <div className='component-table-wrapper h-[calc(100vh-180px)]'>
          <TableContainer
            className='tab-table-container !shadow-none !base-border'
            component='div'
          >
            <Table stickyHeader component='div'>
              <TableHead component='div'>
                <TableRow component='div'>
                  {headCells?.map((cell, i) => (
                    <TableCell key={i} align={'left'}>
                      {cell?.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              {data?.contracts?.length > 0 ? (
                <TableBody
                  className='overflow-hidden !bg-white'
                  component='div'
                >
                  {data?.contracts?.map((row, rowIndex) => {
                    return (
                      <TableRow
                        hover
                        tabIndex={-1}
                        key={'row-' + rowIndex}
                        className='no-underline'
                        component={Link}
                        to={`/admin/contract/view/${row?.id}`}
                      >
                        {columns.map((column, columnIndex) => (
                          <TableCell
                            align={'left'}
                            key={'column-' + columnIndex}
                          >
                            {column?.code == 'status' ? (
                              t('boss.crm.general.active')
                            ) : column.type ? (
                              setTableCellType(column, row[column.code], row)
                            ) : column.code == 'name' ? (
                              <Link
                                className='no-underline text-blue-500'
                                to={`/admin/contract/view/${row?.id}`}
                              >
                                {row[column.code]}
                              </Link>
                            ) : (
                              row[column.code]
                            )}
                          </TableCell>
                        ))}
                      </TableRow>
                    );
                  })}
                </TableBody>
              ) : (
                <TableBody component='div'>
                  <TableRow component='div'>
                    <TableCell colSpan={6}>
                      <span className='text-gray-400 flex items-center justify-center'>
                        <i className='bi bi-exclamation-octagon text-xl leading-4 mr-1' />{' '}
                        {t('common.global.noDataFound')}
                      </span>
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
            </Table>
          </TableContainer>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default memo(ContractInfoModal);
